import { render, staticRenderFns } from "./ReceiverOrderInfoMessages.vue?vue&type=template&id=6cac3070&scoped=true&"
import script from "./ReceiverOrderInfoMessages.vue?vue&type=script&lang=js&"
export * from "./ReceiverOrderInfoMessages.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverOrderInfoMessages.vue?vue&type=style&index=0&id=6cac3070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cac3070",
  null
  
)

export default component.exports